import React, { Component } from "react";
import Reaptcha from "reaptcha";
import api from "../../api";
import settings from "../../settings";

class ReaptchaForm extends Component {
  constructor(props) {
    super(props);
    this.captcha = null;
  }

  onVerify = recaptchaResponse => {
    api.lpUtil
      .validateRecaptcha({
        type: this.props.sitekey,
        response: recaptchaResponse
      })
      .then(res => {
        this.props.onCaptchaResponse(res);
      })
      .catch(err => {
        console.log("captcha error", err);
      });
  };

  render() {
    return (
      <div className={"padding-top-10"}>
        <Reaptcha
          ref={e => {
            this.captcha = e;
          }}
          sitekey={settings.siteKeys[this.props.sitekey]}
          onVerify={this.onVerify}
        />
      </div>
    );
  }
}

export default ReaptchaForm;



// WEBPACK FOOTER //
// ./src/components/forms/ReaptchaForm.js